import React from "react";
import { Text, RadioGroup, Radio } from "@chakra-ui/react";

export const DynoList = ({ dynoList, onListSelectCallback }) => {
  return (
    <>
      <Text
        fontSize="lg"
        fontWeight="bold"
        textAlign="center"
        pb="2"
        width="100%"
      >
        Chapters
      </Text>
      <RadioGroup
        onChange={(value) => onListSelectCallback(value)}
        name="EdDoc-list"
        display="flex"
        alignItems="flex-start"
        flexDirection="column"
        borderTop="1px solid #eee"
        width="100%"
      >
        {dynoList.length > 0 ? (
          dynoList.map((list) => (
            <Radio key={list.id} value={list.id} mt="2" cursor="pointer">
              {list.listName}
            </Radio>
          ))
        ) : (
          <Text pt="2">No Chapters to show.</Text>
        )}
      </RadioGroup>
    </>
  );
};
